import React from 'react';
import classes from './styles/index.module.scss';
import { IconButton } from '../../../../components/IconButton';
import { Undo } from '../../../../components/Icons/Undo';

const AuthenticationBackButton = ({ onClick }) => {
	return (
		<IconButton
			link
			rounded
			size='small'
			styledButton
			onClick={onClick}
			className={classes.authenticationBackButton}
		>
			<Undo />
		</IconButton>
	);
};

export { AuthenticationBackButton };
